import { BrainCircuit, Check, Moon, Radiation, Sun, type LucideIcon } from 'lucide-react';

import { Button } from '../components/Button';
import { Menu } from '../components/Menu';
import { THEMES, useTheme, type Theme } from './theme';

const ICONS: Record<Theme, LucideIcon> = {
    light: Sun,
    dark: Moon,
    ghost: BrainCircuit,
    newvegas: Radiation,
};

// Theme picker — a dropdown in the header chrome (replaces the old light/dark
// toggle). The trigger shows the active theme's icon; the menu lists every
// theme with a check on the current one.
export function ThemeToggle() {
    const { theme, setTheme } = useTheme();
    const Current = ICONS[theme];
    return (
        <Menu
            trigger={
                <Button variant="ghost" size="sm" aria-label="Schimba tema" title="Schimba tema">
                    <Current aria-hidden="true" className="h-5 w-5" />
                </Button>
            }
            items={THEMES.map((t) => {
                const Icon = ICONS[t.value];
                return {
                    icon: <Icon aria-hidden="true" className="h-4 w-4" />,
                    label: (
                        <span className="flex flex-1 items-center justify-between gap-4">
                            {t.label}
                            {theme === t.value && (
                                <Check
                                    aria-hidden="true"
                                    className="h-4 w-4 text-blue-600 dark:text-blue-400"
                                />
                            )}
                        </span>
                    ),
                    onSelect: () => setTheme(t.value),
                };
            })}
        />
    );
}
